import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {useGlobalState, FiltersConfigParam, DFiltersConfigParam} from "./state";
import {QueryParamProvider, StringParam, useQueryParam} from "use-query-params";
import {BrowserRouter as Router, Route, useLocation, useHistory} from "react-router-dom";
// import loadable from '@loadable/component'
import {useDebounceCallback} from "@react-hook/debounce";

// import {QueryClientProvider, QueryClient} from "react-query";
// import { persistQueryClient } from 'react-query/persistQueryClient-experimental'
// import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental'
// import { ReactQueryDevtools } from 'react-query/devtools';
import {QueryClient} from "@tanstack/react-query";
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

import ProductFilters from "./products_list/filters";
import ProductsList from "./products_list/products";
import DiamondFilters from "./diamonds_list/dfilters";
import DiamondsList from "./diamonds_list/diamonds";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, refetchInterval: false, refetchOnMount: false,
            cacheTime: 5 * 60 * 1000, // 5 minutes
        },
    },
})

const localStoragePersistor = createSyncStoragePersister({
    storage: window.localStorage,
})

// const ProductFilters = loadable(() => import('./products_list/filters'))
// const ProductsList = loadable(() => import('./products_list/products'))
//
// const DiamondFilters = loadable(() => import('./diamonds_list/dfilters'))
// const DiamondsList = loadable(() => import('./diamonds_list/diamonds'))

ReactDOM.render(
  <React.StrictMode>
      <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: localStoragePersistor, maxAge: 5 * 60 * 1000 }}>
          <Router>
              <QueryParamProvider ReactRouterRoute={Route} stringifyOptions={{
                  encode: false,
                  sort: (itemLeft, itemRight) => itemLeft.includes('filters') || itemLeft.includes('dfilters') ? 1 : -1}}>
                  <Main/>
              </QueryParamProvider>
          </Router>
          <ReactQueryDevtools initialIsOpen={false} />
      </PersistQueryClientProvider>
  </React.StrictMode>,
  document.getElementById('r-main-block')
);


function Main(props) {
    const location = useLocation();
    const history = useHistory();

    const [initialSetQP, setInitialSetQP] = useState(true);
    const [isFirstLoadFinished] = useGlobalState('firstLoadFinished');

    const [byoStep] = useGlobalState('byoStep');
    const [sortBy] = useGlobalState('sortBy');
    const [sortDirection] = useGlobalState('sortDirection');
    const [filtersConfig] = useGlobalState('filters');
    const [dfiltersConfig] = useGlobalState('dfilters');
    const [dType] = useGlobalState('dType');
    const [dShape] = useGlobalState('dShape');
    const [isGrid] = useGlobalState('isGrid');

    const [, setSortByQP] = useQueryParam('sortBy', StringParam)
    const [, setSortDirectionQP] = useQueryParam('sortDirection', StringParam)
    const [, setFiltersConfigQP] = useQueryParam('filters', FiltersConfigParam)
    const [, setDFiltersConfigQP] = useQueryParam('dfilters', DFiltersConfigParam)
    const [, setDTypeQP] = useQueryParam('dtype', StringParam)
    const [, setDShapeQP] = useQueryParam('dshape', StringParam)
    const [, setIsGridQP] = useQueryParam('isgrid', StringParam)

    const setQueryParams = useDebounceCallback(() => {
        if(!isFirstLoadFinished) return;
        if(initialSetQP) {
            setInitialSetQP(false);
            return;
        }
        if(isDiamondSearchView()) {
            //query params - diamond_list
            history.replace(location.pathname + location.search.replaceAll(new RegExp(/&dfilters.*&|dfilters.*/g), ''));
            setSortByQP(sortBy);
            setSortDirectionQP(sortDirection);
            setDFiltersConfigQP(dfiltersConfig);
            setDTypeQP(dType);
            setDShapeQP(dShape);
            setIsGridQP(isGrid);
        }
        else {
            //query params - product_list
            history.replace(location.pathname + location.search.replaceAll(new RegExp(/&filters.*&|filters.*/g), ''));
            setSortByQP(sortBy);
            setSortDirectionQP(sortDirection);
            setFiltersConfigQP(filtersConfig);
        }
    }, 1000);

    useEffect(() => {
        setQueryParams();
    }, [
        sortBy, sortDirection, filtersConfig, dfiltersConfig, dType, dShape, isGrid
    ])

    useEffect(() => {
        if(location.search.includes('dfilters=&') && (byoStep != null && isDiamondSearchView())) {
            history.replace(location.pathname + location.search.replace('dfilters=&', ''));
        }
        if(location.search.includes('filters=&') && !(byoStep != null && isDiamondSearchView())) {
            history.replace(location.pathname + location.search.replace('filters=&', ''));
        }
    }, [location.search])


    //diamonds list view
    if(byoStep != null && byoStep === 'diamond') {
        return (
            <>
                <DiamondFilters/>
                <DiamondsList/>
            </>
        )
    }
    //product lists (inc. byo)
    else {
        return (
            <>
                <ProductFilters/>
                <ProductsList/>
            </>
        )
    }

    function isDiamondSearchView() {
        return byoStep === 'diamond' && (dType === 'natural' || dType === 'labgrown');
    }
}
